import styled from 'styled-components';

export const StackWrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 5px;
`;

export const ChartLabel = styled.div`
  text-align: center;
  font-size: 12px;
`;

export const TableWrapper = styled.div`
  height: 100%;
  position: relative;
`;

export const EditWrapper = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  justify-content: center;
  align-items: flex-start;
  gap: 10px;
  padding-left: 10px;
`;
